<template>
  <div v-if="showTable" class="company-page-root">
    <div class="styleRow">
      <graph-container></graph-container>
      <notifications></notifications>
      <right-main-chart></right-main-chart>
    </div>

    <clients-table-container
      :salesPersonList="salesPersonList"
      :tabs="tabsList"
      :main-tabs="mainTabsList"
      :users-tabs="usersTabs"
      :brokers-tabs="brokersTabs"
      :update="renderComponent"
    >
    </clients-table-container>
    <div class="styleRow">
      <!--      <comm-container v-if="chartsViewBlocks[3] === null" />-->
      <left-bottom-chart />
      <div class="tempLikeViki">
        <general-live-stats-sub-chart />
      </div>
      <security-cams v-if="chartsViewBlocks[4] === null" />
      <right-bottom-chart v-if="chartsViewBlocks[4] !== null" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import RightMainChart from "../sub_features.company/graph.sub-feature.company/containers/RightMainChart.container";
import GraphContainer from "../sub_features.company/graph.sub-feature.company/containers/Graph.container";
import LeftBottomChart from "../sub_features.company/graph.sub-feature.company/containers/LeftBottomChart.container";
import RightBottomChart from "../sub_features.company/graph.sub-feature.company/containers/RightBottomChart.container";
import ClientsTableContainer from "../sub_features.company/clients_table.sub_feature.company/containers/ClientsTableContainer";
import Notifications from "../../msg_center.feature/containers/Notifications.component";
//import CommContainer from "../../communications.feature/containers/communications.container";
import SecurityCams from "../../security.feature/containers/SecurityCams.container";
import GeneralLiveStatsSubChart from "../sub_features.company/graph.sub-feature.company/components/GeneralLiveStatsSubChart.component";
export default {
  name: "company-container",

  components: {
    Notifications,
    GraphContainer,
    ClientsTableContainer,
    // CommContainer,
    SecurityCams,
    RightMainChart,
    GeneralLiveStatsSubChart,
    LeftBottomChart,
    RightBottomChart
  },

  beforeMount() {
    this.$store.dispatch("clients/getGeneralDictionary").then(res => {
     // this.$store.dispatch("system/getSystemDictionary").then(res => {
        this.$store.dispatch("clients/getActivityDictionary").then(res => {
          this.$store.dispatch("clients/getSalesPersonList").then(res => {
            this.showTable = true;
          });
        });
     // });
    });
  },
  mounted() {
    //this.$store.commit("clients/setVisitedMainPage",true)
  },
  methods: {
    updateClientsTable() {
      this.renderComponent = true;
      this.$nextTick(() => {
        this.renderComponent = false;
      });
    }
  },
  computed: {
    ...mapState("clients", [
      "tabsList",
      "mainTabsList",
      "usersTabs",
      "brokersTabs",
      "salesPersonList",
      "dictionaries",
      "enlargeCompanyTable",
      "chartsViewBlocks"
    ]),
    ...mapState("system", ["systemDictionaries"]),
    ...mapActions("system", ["getSystemDictionary"]),
    ...mapActions("clients", [
      "getActivityDictionary",
      "getGeneralDictionary",
      "getSalesPersonList"
    ])
  },
  data() {
    return {
      showTable: false,
      renderComponent: false,
      users: [
        {
          id: "Today",
          name: 20
        },
        {
          id: "Yesterday",
          name: 15
        },
        {
          id: "Week",
          name: 120
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.company-page-root {
  min-height: 100vh;
  background: #f1f5f9;
  box-sizing: border-box;
}

.table {
  height: 180px;
  width: 100%;
}

.ai-window {
  position: absolute;
  left: 150px;
  width: 180px;
}

.graph-container {
  margin-left: -10px;
  margin-right: -163px;
}
.notifications {
  margin-left: 0px;
  margin-right: -10px;
  width: 100%;
  z-index: 2;
  position: absolute;
}
.card-bottom {
  height: 100%;
}
.bottom-cam {
  height: 240px;
  margin-top: 460px;
  margin-left: -12px;
  margin-right: -10px;
  margin-bottom: -12px;
}
.bottom-chat {
  height: 240px;
  margin-top: 460px;
  margin-left: -10px;
  margin-right: -12px;
  margin-bottom: -12px;
}
.main {
}
.styleRow {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  //margin-bottom: 12px;
}
.clients-table {
}
.tempLikeViki {
  min-width: calc(10%);
  max-width: calc(10%);
  //margin-bottom: 30px;
  max-height: 100%;
}
</style>
